/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import { Link } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import { Button, Col, Form, Row } from "reactstrap";
import bg4 from "../assets/architect/utils/images/originals/bg_white.jpg";
import picLogo from "../assets/architect/utils/images/originals/pic_logo.png";
import CostumForm from "../common/Form/form";
import * as UsersService from "../services/users/api_user";




class Login extends CostumForm {
  constructor(props) {
    super(props);
    this.state = {
      blocking: false,
      credentials: {
        email: "",
        password: "",
      },
      disableChangePasswordButton: false,
      errors: {},
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /*********************************** HANDLERS ***********************************/

  doSubmit = async (e) => {
    e.preventDefault();

    const { credentials } = this.state;
    const data = await UsersService.login(credentials);
    const jwtKey = process.env.REACT_APP_JWT_KEY;

    const { error, code, content } = data.data;

    if (error) {
      const errors = { ...this.state.errors };
      if (error.includes("User") || error.includes("Admin")) {
        errors.email = error;
      } else {
        errors.password = error;
      }

      this.setState({ errors });
    } 
    else if (code != null && code === 0 && content != null && content.token) {
      const jwt = content.token;

      if (jwt !== undefined) {
        localStorage.setItem(jwtKey, jwt);
      }

      window.location = "/";

    }
    else {
      const errors = { ...this.state.errors };
      errors.email = "Unexpected error on login. Please try again.";
      this.setState({ errors });
    }
  };

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  forgotPassword = () => {
    const { credentials } = this.state;
    const this_ = this;

    if (credentials.email.length == 0) {
      const errorMessage = "No email inserted.";

      toast(errorMessage, {
        transition: Bounce,
        closeButton: true,
        autoClose: 2000,
        position: "top-right",
        type: "error",
      });
    } else {
      this_.setState({ disableChangePasswordButton: true });
      const payload = {
        email: credentials.email,
      };
      UsersService.sendResetPasswordEmail(payload, function(result) {
        if (result && result.data && result.data.error) {
          toast(result.data.error, {
            transition: Bounce,
            closeButton: true,
            autoClose: 2000,
            position: "top-right",
            type: "error",
          });
          this_.setState({ disableChangePasswordButton: false });
        } else {
          //Success
          alert("Reset password email sent, please check your email!");
          this_.setState({ disableChangePasswordButton: false });
        }
      });
    }
  };

  render() {
    const { credentials, disableChangePasswordButton } = this.state;
    return (
      <Fragment>
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={<Loader active type="line-scale-pulse-out" />}
        >
          <div className="h-100 bg-animation">
            <div
              className="d-flex h-100 justify-content-center align-items-center"
              style={{
                background: "url(" + bg4 + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            >
              <Col md="8" className="mx-auto app-login-box">
                <div
                  className="modal-dialog w-100 mx-auto"
                  style={{
                    boxShadow: "0px 1px 10px 0px rgba(52, 58, 64, 0.3)",
                  }}
                >
                  <div className="modal-content" style={{ border: "none" }}>
                    <div className="modal-body" style={{ padding: "2.5rem" }}>
                      <div className="h6 modal-title text-center mb-4">
                        <img
                          alt="Company logo"
                          className="mb-4"
                          src={picLogo}
                          style={{ height: "100px", width: "auto" }}
                        />
                        <p>PICAdvanced Client Management Platform</p>
                      </div>
                      <Form onSubmit={this.doSubmit}>
                        <Row form>
                          <Col md={12}>
                            {this.renderInput(
                              "email",
                              "email",
                              "Email",
                              "Enter email"
                            )}
                          </Col>
                          <Col md={12}>
                            {this.renderInput(
                              "password",
                              "password",
                              "Password"
                            )}
                          </Col>
                          <Col md={12} style={{ textAlign: "center" }}>
                            {this.renderButton("Login")}
                          </Col>
                          <Col md={12} style={{ textAlign: "center" }}>
                            <Button
                              style={{
                                marginTop: "5px",
                                background: "#34b4eb",
                                color: "#fff",
                                width: "200px",
                                textAlign: "center",
                              }}
                              disabled={
                                !this.validateEmail(credentials.email) ||
                                disableChangePasswordButton
                              }
                              onClick={this.forgotPassword}
                            >
                              Change my Password
                            </Button>
                          </Col>
                          <Col md={12} style={{ textAlign: "center" }}>
                            <br />

                            <h5 className="mb-0">
                              Don't have account yet?{" "}
                              <Link to="/register" className="text-primary">
                                Register
                              </Link>
                            </h5>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="text-center text-black opacity-8 mt-3">
                  Copyright &copy; PICAdvanced {new Date().getFullYear()}
                </div>
              </Col>
            </div>
          </div>
        </BlockUi>
      </Fragment>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/User/LoginPage.js